import axios from "axios";
import { useEffect, useState } from "react";
// import glass from "../../../assets/images/Enso_010.jpg";
// import glass1 from "../../../assets/images/glass1.jpg";
// import glass2 from "../../../assets/images/glass2.jpg";
// import glass3 from "../../../assets/images/glass3.jpg";
// import glass4 from "../../../assets/images/glass4.jpg";
// import glass5 from "../../../assets/images/glass5.jpg";
// import glass6 from "../../../assets/images/glass6.jpg";
// import glass7 from "../../../assets/images/glass7.jpg";
// import glass8 from "../../../assets/images/glass8.jpg";
// import glass10 from "../../../assets/images/glass10.jpg";
import * as Constants from "../../../constants/Constants";

export const useHomeHook = (props) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fadeClass, setFadeClass] = useState("image-fade");
  const [isHovering, setIsHovering] = useState(false);
  const [menuVisible, setMenuVisible] = useState(false);
  const [showBackground, setShowBackground] = useState(true);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [fadeOut, setFadeOut] = useState(false);
  const [imagesd, setImages] = useState([]);
  // const [hoveredId, setHoveredId] = useState(null);
  // const bgColor = useColorModeValue('white', '#000000');
  // const borderColor = useColorModeValue('#000000', '#000000');
  const images = [imagesd[4]?.image_url, imagesd[7]?.image_url, imagesd[1]?.image_url];
  useEffect(() => {
        axios
          .get(Constants.REACT_APP_API_URL + "api/upload/home")
          .then((res) => {
            if (res.data.success) {
              setImages(res.data.data);
            }
          })
          .catch((err) => console.log(err));
      }, []);

      const productData = [
  {
    src: imagesd[0]?.image_url,
    alt: "Enso Universal",
    description:
      "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  },
];

const imageData = [
  {
    src: imagesd[4]?.image_url,
    alt: "Enso",
    description:
      "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  },
  {
    src: imagesd[3]?.image_url,
    alt: "Metal Doors",
    description:
      "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.",
  },
  {
    src: imagesd[7]?.image_url,
    alt: "glass6 Door",
    description:
      "Duis aute irure dolor in reprehenderit in voluptate velit esse.",
  },
  {
    src: imagesd[2]?.image_url,
    alt: "Veneto",
    description: "Cillum dolore eu fugiat nulla pariatur.",
  },
];
  const currentItem = productData[0];
  const ImageItem = imageData[currentIndex];
  useEffect(() => {
    const interval = setInterval(() => {
      setFadeClass("image-fade");
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        setFadeClass("image-fade active");
      }, 1000);
    }, 6000);
    return () => clearInterval(interval);
  }, [images.length]);
  useEffect(() => {
    setFadeClass("image-fade active");
  }, []);
  useEffect(() => {
    const timers = [
      setTimeout(() => setFadeOut(true), 2000),
      setTimeout(() => setShowBackground(false), 4000),
    ];
    return () => timers.forEach((timer) => clearTimeout(timer));
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowBackground(true);
      } else {
        setShowBackground(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    if (hoveredItem) {
      console.log(`Hovered over: ${hoveredItem}`);
    }
  }, [hoveredItem]);
  // const collections = [
  //   {
  //     id: '1',
  //     title: "Sliding Partitions",
  //     description: "Discover our exquisite range of luxury glass products.",
  //     image: imagesd[4]?.image_url,
  //     size: "small",
  //   },
  //   {
  //     id: '2',
  //     title: "Swing Partitions",
  //     description: "Explore our collection of modern door designs.",
  //     image: imagesd[7]?.image_url,
  //     size: "large",
  //   },
  //   {
  //     id: '3',
  //     title: "Flush Doors",
  //     description: "Stylish and functional wardrobe solutions.",
  //     image: glass,
  //     size: "small",
  //   },
  //   {
  //     id: '4',
  //     title: "Bathroom & Wardrobes",
  //     description: "State-of-the-art shower enclosures for every bathroom.",
  //     image: imagesd[4]?.image_url,
  //     size: "small",
  //   },
  //   {
  //     id: '5',
  //     title: "Shower Enclosures",
  //     description: "Modern and elegant kitchen collections.",
  //     image: imagesd[7]?.image_url,
  //     size: "small",
  //   },
  //   {
  //     id: '6',
  //     title: "Led Mirrors",
  //     description: "Stylish and functional wardrobe solutions.",
  //     image: glass,
  //     size: "small",
  //   },
  // ];
  const handleMenuEnter = () => {
    setMenuVisible(true);
  };
  const handleMenuLeave = (e) => {
    const relatedTarget = e.relatedTarget;
    if (
      relatedTarget instanceof Node &&
      e.currentTarget &&
      document.getElementById("productList")
    ) {
      if (
        !e.currentTarget.contains(relatedTarget) &&
        !document.getElementById("productList").contains(relatedTarget)
      ) {
        setMenuVisible(false);
      }
    }
  };
  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % imageData.length);
  };
  const handlePrevious = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + imageData.length) % imageData.length
    );
  };
  // const productImages = {
  //   "Sliding Partitions": imagesd[4]?.image_url,
  //   "Swing Partitions": imagesd[7]?.image_url,
  //   "Flush Doors": glass3,
  //   "Bathroom & Wardrobes": glass4,
  //   "Shower Enclosures": glass5,
  //   "Led Mirrors": glass6,
  // };
  return [
    handleMenuEnter,
    handleMenuLeave,
    menuVisible,
    setHoveredItem,
    showBackground,
    fadeOut,
    currentItem,
    handlePrevious,
    handleNext,
    isHovering,
    setIsHovering,
    ImageItem,
    fadeClass,
  ];
};

export default useHomeHook;
